const LinkedinIcon = ({ color }: { color?: string }) => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.9408 0H2.67207C1.36582 0 0.30957 1.03125 0.30957 2.30625V29.6875C0.30957 30.9625 1.36582 32 2.67207 32H29.9408C31.2471 32 32.3096 30.9625 32.3096 29.6938V2.30625C32.3096 1.03125 31.2471 0 29.9408 0ZM9.80332 27.2687H5.05332V11.9937H9.80332V27.2687ZM7.42832 9.9125C5.90332 9.9125 4.67207 8.68125 4.67207 7.1625C4.67207 5.64375 5.90332 4.4125 7.42832 4.4125C8.94707 4.4125 10.1783 5.64375 10.1783 7.1625C10.1783 8.675 8.94707 9.9125 7.42832 9.9125ZM27.5783 27.2687H22.8346V19.8438C22.8346 18.075 22.8033 15.7937 20.3658 15.7937C17.8971 15.7937 17.5221 17.725 17.5221 19.7188V27.2687H12.7846V11.9937H17.3346V14.0813H17.3971C18.0283 12.8813 19.5783 11.6125 21.8846 11.6125C26.6908 11.6125 27.5783 14.775 27.5783 18.8875V27.2687Z"
      fill={color || "white"}
    />
  </svg>
);

export default LinkedinIcon;
